import React, { useState } from "react";
import {
  Typography,
  Tabs,
  Row,
  Col,
  Spin,
  Button,
  Input,
  Select,
  Empty,
} from "antd";
import {
  AppstoreAddOutlined,
  UserOutlined,
  FileDoneOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import ServiceCard from "../../components/ServiceCard/serviceCard.component";
import NewService from "../../components/NewService/newService.component";
import useService from "../../hooks/useService";
import OrdersTable from "../../components/OrdersTable/ordersTable.component";
import { useAuth } from "../../contexts/AuthContext/auth.context";
import { ServiceOrder } from "../../types/serviceOrder.type";

const { Title } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

export default function Services() {
  const { authState } = useAuth();
  const {
    services,
    myServices,
    loading,
    takeService,
    deleteService,
    updateService,
    createService,
    setSearchTerm,
    setSortCriteria,
    setSortOrder,
    orders,
    cancelOrder,
    changeOrderStatus,
  } = useService();

  const [isNewServiceModalVisible, setIsNewServiceModalVisible] =
    useState(false);

  const userRole = (order: ServiceOrder) => {
    if (authState?._id === order.owner) return "owner";
    if (authState?._id === order.customer) return "customer";
    return null;
  };

  return (
    <div style={{ padding: "16px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 24,
        }}
      >
        <Title level={2}>Услуги</Title>
        <Button
          type="primary"
          icon={<PlusCircleOutlined />}
          onClick={() => setIsNewServiceModalVisible(true)}
        >
          Новый
        </Button>
      </div>

      {loading ? (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          <Spin size="large" />
          <p>Загрузка услуг...</p>
        </div>
      ) : (
        <Tabs defaultActiveKey="1" style={{ marginTop: 16 }}>
          <TabPane
            tab={
              <span>
                <AppstoreAddOutlined /> Все
              </span>
            }
            key="1"
          >
            <div style={{ marginBottom: 24 }}>
              <Input
                allowClear
                placeholder="Поиск"
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ marginBottom: 16, width: 300 }}
              />
              <Select
                allowClear
                placeholder="Сортировка"
                onChange={(value) =>
                  setSortCriteria(value as "title" | "price" | "date")
                }
                style={{ width: 200, marginRight: 16 }}
              >
                <Option value="title">Сортировка по названию</Option>
                <Option value="price">Сортировка по цене</Option>
                <Option value="date">Сортировка по дате</Option>
              </Select>
              <Select
                allowClear
                placeholder="Тип сортировки"
                onChange={(value) => setSortOrder(value as "asc" | "desc")}
                style={{ width: 200 }}
              >
                <Option value="asc">По возрастанию</Option>
                <Option value="desc">По убыванию</Option>
              </Select>
            </div>
            {services.length === 0 ? (
              <Empty description="Нет доступных услуг" />
            ) : (
              <Row gutter={[16, 16]}>
                {services.map((service) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={service._id}>
                    <ServiceCard
                      service={service}
                      onTakeService={() => takeService(service._id)}
                    />
                  </Col>
                ))}
              </Row>
            )}
          </TabPane>
          <TabPane
            tab={
              <span>
                <UserOutlined /> Мои Услуги
              </span>
            }
            key="2"
          >
            {myServices.length === 0 ? (
              <Empty description="У вас нет собственных услуг" />
            ) : (
              <Row gutter={[16, 16]}>
                {myServices.map((service) => (
                  <Col xs={24} sm={12} md={8} lg={6} key={service._id}>
                    <ServiceCard
                      service={service}
                      isMyService={true}
                      onUpdateService={updateService}
                      onDeleteService={(id: string) => deleteService(id)}
                    />
                  </Col>
                ))}
              </Row>
            )}
          </TabPane>
          <TabPane
            tab={
              <span>
                <FileDoneOutlined /> Заказы
              </span>
            }
            key="3"
          >
            <OrdersTable
              orders={orders}
              userRole={(order) => userRole(order)}
              onStatusChange={(orderId, newStatus) =>
                changeOrderStatus(orderId, newStatus)
              }
              onCancelOrder={cancelOrder}
            />
          </TabPane>
        </Tabs>
      )}
      <NewService
        visible={isNewServiceModalVisible}
        onClose={() => setIsNewServiceModalVisible(false)}
        onCreateService={createService}
      />
    </div>
  );
}
